<script>
  import { style, blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link } from "svelte-routing";

  export let block;
</script>

<!-- -------- START Features w/ image on left & title & text & 3 cols on soft background -------- -->
<section style="{style(block)}">
  <div class="container-fluid px-0">
    <div class="row justify-content-center text-center">
      <div class="col-3 px-md-0"></div>
      <div class="col-12 position-relative">
        <div class="row">
          <div class="col-xl-3"></div>
          <div class="col-xl-5 col-md-8 col-12 text-start">
            <div class="p-3 text-start border-radius-lg">
              <h2>{text(block, 'headline')}</h2>
              <p class="text-dark text-lg mt-3">
                {@html richtext(block, 'body')}
              </p>
            </div>
          </div>
        </div>
        <div class="row bg-warning-soft bottom-0">
          <div class="row">
            <div class="col-xl-3 position-relative">
              <img class="w-100 border-radius-section border-top-start-radius-0 border-bottom-start-radius-0 start-0 position-absolute max-width-300 mt-n11 d-xl-block d-none"
                   src="{image(block, 'background', [400, 800])}" alt="image">
            </div>
            <div class="col-xl-9">
              <div class="row">
                {#each blocklist(block, 'features') as item}
                <div class="col-xl-3 col-md-4 py-md-5 py-3">
                  <div class="p-3 text-start border-radius-lg">
                    <div class="icon icon-shape icon-md bg-gradient-info shadow text-center">
                      <img src="{image(item, 'icon', [50, 50])}" alt="Icon">
                    </div>
                    <h5 class="mt-3">{text(item, 'headline')}</h5>
                    <p>{@html richtext(item, 'body')}</p>
                  </div>
                </div>
                {/each}
              </div>
            </div>
            <div class="col-md-1"></div>
          </div>
          <img class="w-10 end-10 position-absolute mt-n6" src="../../assets/img/pattern-points.png" alt="image">
        </div>
      </div>
    </div>
</section>
<!-- -------- END Features w/ image on left & title & text & 3 cols on soft background -------- -->

